import { ClassOfDropdownTransferModule } from '../../shared/components/class-of-dropdown-transfer/class-of-dropdown-transfer.module';
import { ClassOfDropdownModule } from '../../shared/components/class-of-dropdown/class-of-dropdown.module';
// tslint:disable-next-line:max-line-length
import { PlannedGraduationDropdownModule } from '../../shared/components/planned-graduation-dropdown/planned-graduation-dropdown.module';
// TODO - everything in directives folder is actually now component. Should move to shared/components and correct path here. - JYR
import { SupportDuplicatorModule } from '../../shared/directives/support-duplicator/support-duplicator.module';
import { NotificationsModule } from './notifications/notifications.module';
import { TooltipWarningModule } from './tooltip-warning/tooltip-warning.module';

export default angular.module('nv.components', [
  'nv.components.autocomplete-floating-label',
  'nv.components.sorter-col-input',
  'nv.components.sorter-col-input-details',
  'nv.components.tooltip',
  'nv.components.tooltip-open',
  ClassOfDropdownModule,
  ClassOfDropdownTransferModule,
  PlannedGraduationDropdownModule,
  TooltipWarningModule,
  SupportDuplicatorModule,
  NotificationsModule,
]).name;
